import NewDealContainer from 'containers/Deal/NewDeal'
import React from 'react'

const NewDealPage = () => {
  return <NewDealContainer />
}

export default NewDealPage
